import React, { useEffect, useRef, useState } from 'react';
import classes from './style/Player.module.css';
import Hls from 'hls.js';
import { ApiCenter } from '../../../../api/ApiCenter';
import { getHlsStreamUrl } from '../../../../api/api';

interface PlayerProps {
  order: number;
  title: string;
  link: string;
  access_token: string; // Добавляем токен в пропсы
  id: number;
}

const Player: React.FC<PlayerProps> = ({ order, title, link, access_token, id }) => {
  const [videoUrl, setVideoUrl] = useState<string | null>(null); // Состояние для хранения URL видео
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const Apistart = new ApiCenter();

  useEffect(() => {
    const fetchVideoUrl = async () => {
      try {
        const response = await getHlsStreamUrl(link);
        console.log('Fetched video URL:', response); // Логирование URL
        setVideoUrl(response);
      } catch (error) {
        console.error('Error fetching video URL:', error);
      }
    };
    fetchVideoUrl();
    const video = videoRef.current;
    console.log('videoUrl', videoUrl);
    if (video && videoUrl) {
      if (Hls.isSupported()) {
        const hls = new Hls({
          xhrSetup: function (xhr, url) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('access_token'));
            xhr.setRequestHeader('Accept', 'application/json');
            if (url.endsWith('.ts')) {
              // Заменяем .m3u8 на .ts
              console.log('tsUrl', url.endsWith('.ts'), url);

              // Находим индекс последнего слеша
              const lastSlashIndex = url.lastIndexOf('/');

              const fileName = url.substring(lastSlashIndex + 1);

              // Извлекаем имя файла (все, что после последнего слеша)
              const origPth = videoUrl.lastIndexOf('/');
              const fileNameorigPth = videoUrl.substring(0, origPth);
              // Логируем имя файла
              console.log('File Name:', fileNameorigPth + '/' + fileName);
              xhr.open('GET', fileNameorigPth + '/' + fileName, true); // Изменяем метод запроса на новый URL
            }
          },
        });
        console.log(videoUrl);
        hls.loadSource(videoUrl);
        hls.attachMedia(video);

        return () => {
          hls.destroy();
        };
      } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoUrl;
      }
    }
  }, [id, videoUrl]);

  return (
    <div>
      <h1>{`Урок ${order}. ${title}`}</h1>
      <video
        ref={videoRef}
        className={classes.player}
        controls
        style={{ width: '100%', height: 'auto' }}
      />
    </div>
  );
};

export default Player;
